'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tcnp = exports.tcp = exports.tcn = exports.tc = exports.tnp = exports.tp = exports.tn = exports.t = exports.tinp = exports.tip = exports.tin = exports.ti = undefined;

var _lodash = require('lodash.curry');

var _lodash2 = _interopRequireDefault(_lodash);

var _interpolators = require('./interpolators.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ti = exports.ti = (0, _lodash2.default)(function (interpolate, translate, message) {
  var scope = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  return interpolate(translate(message), scope);
});

var tin = exports.tin = (0, _lodash2.default)(function (interpolate, translate, one, other, count) {
  var scope = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

  return interpolate(translate(one, other, count), scope);
});

var tip = exports.tip = (0, _lodash2.default)(function (interpolate, translate, context, message) {
  var scope = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  return interpolate(translate(context, message), scope);
});

var tinp = exports.tinp = (0, _lodash2.default)(function (interpolate, translate, context, one, other, count) {
  var scope = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

  return interpolate(translate(context, one, other, count), scope);
});

var t = exports.t = ti(_interpolators.interpolateString);
var tn = exports.tn = tin(_interpolators.interpolateString);
var tp = exports.tp = tip(_interpolators.interpolateString);
var tnp = exports.tnp = tinp(_interpolators.interpolateString);

var tc = exports.tc = ti(_interpolators.interpolateComponents);
var tcn = exports.tcn = tin(_interpolators.interpolateComponents);
var tcp = exports.tcp = tip(_interpolators.interpolateComponents);
var tcnp = exports.tcnp = tinp(_interpolators.interpolateComponents);